/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AuthRoles } from 'jotai/auth';
import { authService } from 'services/auth/AuthService';

const isFeaturePreviewUser = () => {
  const userRoles = authService.getRoles(process.env.REACT_APP_ROLE_COMPTOOLS_REALM.toString());
  const authorizedPreviewRoles: string[] = [AuthRoles.ADMIN, AuthRoles.FeaturePreview];
  return userRoles && userRoles?.some((item) => authorizedPreviewRoles.includes(item));
};

export default isFeaturePreviewUser;
